import React from 'react';
import { Checkbox } from 'react-bootstrap';
import './Checkbox.css';

export default (props) => {
  const { children, ...rest } = props;
  return (
    <div className="distilled-checkbox">
      <Checkbox {...rest}>
        <span className="checkmark" />
        {children}
      </Checkbox>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/Checkbox.js